import type React from 'react';
import { useMemo, useState } from 'react';
import { RulesContentContext } from './RulesContentContext';
import { RulesContentCreationForm } from './RulesContentCreationForm';
import { RulesContentList } from './RulesContentList';

export interface RulesContentProps {
  children?: React.ReactNode;
}

const RulesContent = ({ children }: RulesContentProps) => {
  const [openedRules, setOpenedRules] = useState<string[]>([]);

  const contextState = useMemo(
    () => ({
      openedRules,
      openRule: (id: string) => setOpenedRules([id]),
      closeRule: (id: string) =>
        setOpenedRules((openedRules) =>
          openedRules.filter((ruleId) => ruleId !== id)
        ),
      closeAllRules: () => setOpenedRules([]),
      showCreationForm: () => {
        if (openedRules.length) {
          setOpenedRules([]);
        }
      },
    }),
    [openedRules]
  );

  return (
    <RulesContentContext.Provider value={contextState}>
      {children}
    </RulesContentContext.Provider>
  );
};

const _RulesContent = Object.assign(RulesContent, {
  CreationForm: RulesContentCreationForm,
  List: RulesContentList,
});

export { _RulesContent as RulesContent };
